import _ from 'underscore';
import { Status } from '@bingads-webui-campaign-react/diagnostic-card';

import { DetailCardsKey } from './const';

const CardStatus = {
  Error: {
    title: _TL_('Your campaign\'s performance is blocked'),
    text: _TL_('Troubleshoot your campaign\'s performance by following these steps:'),
  },
  Warning: {
    title: _TL_('Let\'s improve your campaign\'s performance'),
    text: _TL_('You can improve your campaigns by using following these steps:'),
  },
  Active: {
    title: _TL_('Your campaign is performing well'),
    text: _TL_('Check in regularly to ensure your campaign continues to perform.'),
  },
  Pending: {
    title: _TL_('Your campaign is under review'),
    text: _TL_('The review may take up to two days. In the meantime, please consider these suggestions to optimize your campaign.'),
  },
};

const hasError = details => details.some(item => item.status === Status.Error);
const hasWarning = details => details.some(item => item.status === Status.Warning);
const isCampaignActive = (details) => {
  const campaignDetail = details.find(item => item.key === DetailCardsKey.campaign);
  return _.get(campaignDetail, 'status') === Status.Active;
};

const logStatusText = ({ status, texts, activity }) => activity.trace(`DiagnosticCard status text - status:${status} title:${texts.title} text:${texts.text}`);

export function getCardStatusText(details, activity, i18n) {
  let texts = {};

  if (hasError(details)) {
    texts = CardStatus.Error;
    logStatusText({ status: 'Error', texts, activity });
  } else if (hasWarning(details)) {
    texts = CardStatus.Warning;
    logStatusText({ status: 'Warning', texts, activity });
  } else if (isCampaignActive(details)) {
    texts = CardStatus.Active;
    logStatusText({ status: 'Active', texts, activity });
  } else {
    texts = CardStatus.Pending;
    logStatusText({ status: 'Pending', texts, activity });
  }

  return {
    campaignStatusTitle: i18n.getString(texts.title),
    campaignStatusMsg: i18n.getString(texts.text),
  };
}
